import { render } from "./edit-form.vue?vue&type=template&id=13147222&scoped=true"
import script from "./edit-form.vue?vue&type=script&lang=js"
export * from "./edit-form.vue?vue&type=script&lang=js"

import "./edit-form.vue?vue&type=style&index=0&id=13147222&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13147222"]])

export default __exports__